import { render, staticRenderFns } from "./OrderItemTable.vue?vue&type=template&id=697c4b07&scoped=true&"
import script from "./OrderItemTable.vue?vue&type=script&lang=js&"
export * from "./OrderItemTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemTable.vue?vue&type=style&index=0&id=697c4b07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697c4b07",
  null
  
)

export default component.exports